import React from "react";

function WebhookInfoCard({icon: Icon,label,value,iconClass}) {
  return (
    <div className="rounded-xl border border-[#dfeaf0] bg-white p-3 dark:border-dark-border dark:bg-dark-card">
      <div className="flex items-center gap-2">
        <div className={`flex h-7 w-7 items-center justify-center rounded-md ${iconClass}`}>
          <Icon size={13} />
        </div>
        <span className="text-[8px] font-bold uppercase tracking-[0.08em] text-[#8194a0] dark:text-dark-text-muted">
          {label}
        </span>
      </div>
      <p className="mt-2 truncate text-[9px] font-bold text-[#526b7b] dark:text-dark-text-secondary">
        {value}
      </p>
    </div>
  );
}

export default WebhookInfoCard;
